import { twMerge } from 'tailwind-merge';
import React from 'react';

interface Props {
    message: string;
    className?: string;
}

const EmptyState = ({ message, className = '' }: Props) => {
    return (
        <div
            className={twMerge(
                'flex h-16 items-center justify-center rounded-sm bg-gray-200',
                className,
            )}
        >
            <p className="text-sm text-gray-500">{message}</p>
        </div>
    );
};

export default EmptyState;
